import React from "react";
import './i18n';  //// import i18n (needs to be bundled ;)) 
import { useTranslation } from 'react-i18next';
import {
  FaCar,
  FaParking,
  FaUtensils,
  FaDumbbell,
  FaWifi,
  FaDog,
  FaSwimmingPool,
  FaHotTub,
  FaSpa,
  FaLeaf,
  FaBaby,
  FaWheelchair
} from "react-icons/fa";

const iconMap = {
  "car rent": <FaCar className="text-blue-500" />,
  "parking": <FaParking className="text-blue-500" />,
  "restaurant": <FaUtensils className="text-green-500" />,
  "fitness": <FaDumbbell className="text-red-500" />,
  "WiFi": <FaWifi className="text-purple-500" />,
  "pets allowed": <FaDog className="text-yellow-600" />,
  "swimming pool": <FaSwimmingPool className="text-cyan-500" />,
  "termal pool": <FaHotTub className="text-pink-500" />,
  "sauna": <FaSpa className="text-orange-500" />,
  "diet meal": <FaLeaf className="text-green-400" />,
  "baby sitting": <FaBaby className="text-indigo-500" />,
  "for people with disabilites": <FaWheelchair className="text-gray-600" />
};

const ResortFeaturesList = ({ features }) => {
  const { t } = useTranslation();
  return (
    <ul className="resort-feature-list-container">
      {features.map((item, index) => (
        <li key={index} className="resort-feature">
          <span className="icon">{iconMap[item.type] || "❓"}</span>
          <span className="label">{t(item.type)}</span>
        </li>
      ))}
    </ul>
  );
};

export default ResortFeaturesList;
